/**
 * The v2 trade-table column-mapping targets that start unmapped (`null`).
 *
 * The backend GET hydration (`rulesToBasicColumnMapping`) and the template
 * editor's blank state (`createDefaultColumnMapping`) must start from the SAME
 * list, otherwise a target added on one side is `undefined` on the other. A fresh
 * object per call so no caller can mutate a shared default.
 */
export function createEmptyColumnMappingSlots() {
  return {
    date: null,
    // Issue #356: optional separate Time column. null = legacy behavior.
    timeColumn: null,
    amount: null,
    coin: null,
    // Literal constant asset (Nicehash-style header-only currency). Persisted as
    // a normal string rule, so it round-trips.
    coinConstant: null,
    // Constant base/quote assets (pair path) — literal, persisted as normal
    // string rules so they round-trip.
    baseAssetConstant: null,
    quoteAssetConstant: null,
    operationType: null,
    incomingAmount: null,
    incomingAsset: null,
    outgoingAmount: null,
    outgoingAsset: null,
    commissionAmount: null,
    commissionAsset: null,
    comment: null,
    operationId: null,
  } as const
}
